import { gql } from "@apollo/client";

export const removeLibraryCategory = gql`
  mutation removeLibraryCategory($_id: MongoID!) {
    libraryCategory_RemoveById(_id :$_id) {
      record {
        _id
      }
    }
  }
`;